import { render, staticRenderFns } from "./CompanyHits.vue?vue&type=template&id=3f334d9b"
import script from "./CompanyHits.vue?vue&type=script&lang=js"
export * from "./CompanyHits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports